document.addEventListener('DOMContentLoaded', () => {
    const main = document.querySelector('#primary');
    const menu = document.querySelector('#menu-podreczne');
    const menuList = menu?.querySelector('ul');

    if (!main || !menu || !menuList) {
        return;
    }

    const excludedSectionIds = [
        'sekcja-wstepu-i-opis',
        'dolna-nawigacja',
        'lista',
    ];

    const usedIds = new Set(
        Array.from(document.querySelectorAll('[id]'))
            .map((element) => element.id)
            .filter(Boolean)
    );

    const createSectionId = (title, index) => {
        const baseId = title
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '') || `sekcja-${index + 1}`;

        let sectionId = baseId;
        let suffix = 2;

        while (usedIds.has(sectionId)) {
            sectionId = `${baseId}-${suffix}`;
            suffix += 1;
        }

        usedIds.add(sectionId);

        return sectionId;
    };

    const sections = Array.from(main.querySelectorAll('section'))
    .filter((section) => {
        return !excludedSectionIds.includes(section.id);
    });

    sections.forEach((section, index) => {
        const heading = section.querySelector('h2, h3');

        if (!heading) {
            return;
        }

        const title = heading.textContent
            .replace(/\s+/g, ' ')
            .trim();

        if (!title) {
            return;
        }

        if (!section.id) {
            section.id = createSectionId(title, index);
        }

        const listItem = document.createElement('li');
        const link = document.createElement('a');

        link.href = `#${section.id}`;
        link.textContent = title;

        link.addEventListener('click', (event) => {
            event.preventDefault();

            if (typeof window.smoothScrollToId === 'function') {
                window.smoothScrollToId(section.id, 500, 30);
                return;
            }

            section.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });

        listItem.appendChild(link);
        menuList.appendChild(listItem);
    });

    if (!menuList.children.length) {
        menu.hidden = true;
    }
});